import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function ManageUserCustomerCoWorkerMenu({ activeItem = null }) {
  return (
    <>
      <li className="nav-item">
        <Link
          to="/user/all-customer-coworker"
          className={`nav-link  d-flex
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "user-customer-coworker"
                      )} `}
        >
          <i className="nav-icon fa fa-users"></i>
          <p>کاربران </p>
        </Link>
      </li>
    </>
  );
}
